import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { DialogTitle } from '@mui/material';
import { BootstrapDialog } from 'components/subUsers/AddSubUsers';
import { getQuoation } from 'slices/translationSlice';
import ViewTable from './ViewTable';
import { useTranslation } from 'react-i18next';

export const ViewQuotationModal = ({ itemId, onClose, show, item }) => {
    const { t } = useTranslation();
    // const [item, setItem] = React.useState({});
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(false);

    // useEffect(() => {
    //     const callBack = (success, data) => {
    //         setLoading(false);
    //         if (success) {
    //             setItem(data);
    //         } else {
    //             setItem({});
    //         }
    //     };
    //     dispatch(getQuoation(itemId, callBack))
    // }, [itemId])

    return (
        <BootstrapDialog
            fullWidth={true}
            maxWidth={"md"}
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={show}


        >
            <div className="">
                <div className="modal-content full_modal">
                    <DialogTitle>
                        <div className="modal-header header_modal align-items-center">
                            <div></div>
                            <h5 className="modal-title_u">{t('translationView.quotationView')}</h5>
                            <button type="button" className="btn-close"
                                // ref={refCloseScheduleButton} data-bs-dismiss="modal" 
                                aria-label="Close"
                                onClick={
                                    () => {
                                        onClose();
                                    }
                                }

                            ></button>
                        </div>
                    </DialogTitle>
                    <div className="modal-body modal_form_body">
                        <ViewTable item={item?.quotations?.find(i=>i?.id===itemId)} phase={item?.translation_details?.current_phase} totalQuantity={item?.translation_details?.total_quantity} />
                    </div>
                </div>
            </div>
        </BootstrapDialog>
    )
}
